module.exports = __webpack_public_path__ + "img/reviews.4d7817f3.png";